import { render } from "./legoTabContent.vue?vue&type=template&id=05f1da3a"
import script from "./legoTabContent.vue?vue&type=script&lang=js"
export * from "./legoTabContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/boxes/legoTabBox/legoTabContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05f1da3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05f1da3a', __exports__)) {
    api.reload('05f1da3a', __exports__)
  }
  
  module.hot.accept("./legoTabContent.vue?vue&type=template&id=05f1da3a", () => {
    api.rerender('05f1da3a', render)
  })

}


export default __exports__